import { getProductBaseCategory, isBatteryProduct } from '@/utilities/getProductBaseCategory';

import { productRequestRouteByVehicleType } from '@/constants/product';

import { ProductType } from '@/server/services/core/product/models';
import { ProductBatteryType } from '@/server/services/core/productBattery/models';

type ProductBuyHrefOptions = {
    categoryId?: number;
};

export const getProductBuyHref = (product: ProductType & Partial<ProductBatteryType>, options?: ProductBuyHrefOptions) => {
    const baseCategory = getProductBaseCategory(product);
    const detailsHref = `/product/${product.uuid}/${product.slug}`;

    if (!isBatteryProduct(product)) {
        return detailsHref;
    }

    const requestRoute = productRequestRouteByVehicleType[baseCategory.slug as keyof typeof productRequestRouteByVehicleType];
    const categoryQuery = options?.categoryId ? `&categoryId=${options.categoryId}` : '';

    return `/${baseCategory.slug}${requestRoute}?productId=${product.uuid}${categoryQuery}`;
};
